const UserPrefrencesList = [
  {
    access_name: "APPNOTIFY",
    access_label: "Application Notifications"
  },
  {
    access_name: "SMSNOTIFY",
    access_label: "SMS Notifications"
  },
  {
    access_name: "EMAILNOTIFY",
    access_label: "Email Notifications"
  },
  {
    access_name: "DESKNOTIFY",
    access_label: "Desktop Notifications"
  },
  {
    access_name: "MARKETINGEMAIL",
    access_label: "Marketing Emails"
  },
  {
    access_name: "PERSONALEMAIL",
    access_label: "My Personal Measurement Results"
  },
  {
    access_name: "AGGREGATEEMAIL",
    access_label: "Aggregate Results for Experiences I Participate In"
  },
  {
    access_name: "RESOURCEEMAIL",
    access_label: "Immersion Resources"
  },
  {
    access_name: "AUTOJOIN",
    access_label: "Auto Join"
  },
  {
    access_name: "AUTOSTART",
    access_label: "Auto Start"
  },
  {
    access_name: "ALLOWPERSONAL",
    access_label: "Allow Personal Analysis"
  },
  {
    access_name: "ALLOWAGGREGATE",
    access_label: "Allow Aggregate Analysis"
  },
  {
    access_name: "ANONYMOUS",
    access_label: "Anonymize My Data"
  },
  {
    access_name: "MODERATED",
    access_label: "Enable moderated events"
  },
  {
    access_name: "ASYNC",
    access_label: "Enable asynchronous events"
  },
  {
    access_name: "VIDEOSECURITY",
    access_label: "Enhanced video security"
  },
  {
    access_name: "CALENDAR",
    access_label: "Integrate Calendar"
  },
  {
    access_name: "TIMEZONE",
    access_label: "Timezone"
  },

];

export default UserPrefrencesList;